import { useSyncExternalStore } from 'react'
import type { InboundSalesAvailability } from '@/app/api/inbound-sales/availability/route'
import { logger } from '@/services/logger/logger.client'

const CLOSED: InboundSalesAvailability = { isOpen: false, phone: null }

let state: InboundSalesAvailability = CLOSED
const listeners = new Set<() => void>()
let intervalId: ReturnType<typeof setInterval> | null = null

function subscribe(cb: () => void) {
  if (listeners.size === 0) {
    fetchAvailability()
    intervalId = setInterval(fetchAvailability, 60_000)
  }
  listeners.add(cb)

  return () => {
    listeners.delete(cb)
    if (listeners.size === 0 && intervalId !== null) {
      clearInterval(intervalId)
      intervalId = null
    }
  }
}

function notify() {
  listeners.forEach((cb) => cb())
}

async function fetchAvailability() {
  try {
    const res = await fetch('/api/inbound-sales/availability')
    if (!res.ok) {
      throw new Error(res.statusText)
    }
    state = (await res.json()) as InboundSalesAvailability
  } catch (err) {
    state = CLOSED
    logger.error('Failed to fetch inbound sales availability', { err })
  }
  notify()
}

export function useInboundSalesOpen(): InboundSalesAvailability {
  return useSyncExternalStore(
    subscribe,
    () => state,
    () => CLOSED,
  )
}
